const initialState = {
    data: null,
}
export const SharedFromMeReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SHAREDFROMME_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'SHAREDFROMME_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default SharedFromMeReducer;